import { render, staticRenderFns } from "./ListCondominium.vue?vue&type=template&id=3ab35228"
import script from "./ListCondominium.vue?vue&type=script&lang=js"
export * from "./ListCondominium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports